<template>
  <div>
    <div
      class="push-notification-message-container p-3 mt-3"
      :class="{
        'input--error':
          isSubmit &&
          (errorMessageTemplates || checkMessageTemplatesPushNotiErrorExist),
      }"
    >
      <h5 class="mb-0">Push notification</h5>
      <div class="row">
        <div class="col-9">
          <label :for="'messageTitle_' + identifier">
            Message title<span class="required">*</span></label
          >
          <input
            :id="'messageTitle_' + identifier"
            type="text"
            v-model="messageTitle"
            class="form-control"
            :class="{
              'input--error':
                isSubmit &&
                messageTemplate &&
                !messageTemplate.messageTitle &&
                error.errorMessageTitle,
            }"
            :disabled="isDisabled"
          />
          <div
            v-if="
              isSubmit &&
              messageTemplate &&
              !messageTemplate.messageTitle &&
              error.errorMessageTitle
            "
            class="text-error"
          >
            {{ error.errorMessageTitle.message }}
          </div>
        </div>
      </div>
      <CommonMessageTemplate
        v-model="messageTemplatePushNoti"
        :trigger-type="triggerType"
        :has-top40="hasTop40"
        :is-submit="isSubmit"
        :is-broadcast="isBroadcast"
        :is-remark-shown="isRemarkShown"
        :is-disabled="isDisabled"
        label="Message template"
        :data-id="dataId"
        :error-message-template="errorMessageTemplates"
        :identifier="identifier + '_pushNotification'"
      />
      <div class="row">
        <div class="col-9">
          <label :for="'targetHttpsUrl_' + identifier">
            Target HTTPS URL<span class="required">*</span></label
          >
          <input
            :id="'targetHttpsUrl_' + identifier"
            type="text"
            v-model="pushNotiTargetUrl"
            class="form-control"
            :class="{
              'input--error':
                isSubmit &&
                messageTemplate &&
                !messageTemplate.pushNotiTargetUrl &&
                error.errorPushNotiTargetUrl,
            }"
            :disabled="isDisabled"
          />
          <div
            v-if="
              isSubmit &&
              messageTemplate &&
              !messageTemplate.pushNotiTargetUrl &&
              error.errorPushNotiTargetUrl
            "
            class="text-error"
          >
            {{ error.errorPushNotiTargetUrl.message }}
          </div>
        </div>
      </div>
      <div class="row d-flex align-items-center">
        <div class="col-3">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input mr-2"
              :id="'showInInbox_' + identifier"
              type="checkbox"
              ref="chkVideo"
              v-model="showInInbox"
              :disabled="isDisabled"
              :class="{
                'input--error':
                  isSubmit &&
                  messageTemplate &&
                  !messageTemplate.showInInbox &&
                  error.errorShowInInbox,
              }"
            />
            <label class="form-check-label" :for="'showInInbox_' + identifier"
              >Show in inbox</label
            >
          </div>
          <div
            v-if="
              isSubmit &&
              messageTemplate &&
              !messageTemplate.showInInbox &&
              error.errorShowInInbox
            "
            class="text-error"
          >
            {{ error.errorShowInInbox.message }}
          </div>
        </div>
        <div class="col-6" v-if="isBroadcast">
          <label :for="'showUntil_' + identifier"
            >Show until<span class="required">*</span></label
          >
          <VueCtkDateTimePicker
            :id="'showUntil_' + identifier"
            v-model="showUntil"
            format="DD/MM/YYYY HH:mm"
            formatted="DD MMM YYYY HH:mm"
            :noHeader="true"
            :noLabel="true"
            class="control"
            :class="{
              'input--error': isSubmit && error.errorShowUntil,
            }"
            :disabled="isDisabled"
          />
          <div v-if="isSubmit && error.errorShowUntil" class="text-error">
            {{ error.errorShowUntil.message }}
          </div>
        </div>
        <div class="col-6" v-else>
          <label :for="'showPeriodInDays_' + identifier">
            Show period (days)<span class="required">*</span></label
          >
          <NumberInput
            :input-id="'showPeriodInDays_' + identifier"
            v-model="showPeriodInDays" :dynamic-class="{
              'input--error':
                isSubmit &&
                messageTemplate &&
                !messageTemplate.showPeriodInDays &&
                error.errorShowPeriodInDays,
            }"
            :disabled="isDisabled"
            :is-decimal-allowed="true"
          />
          <div
            v-if="
              isSubmit &&
              messageTemplate &&
              !messageTemplate.showPeriodInDays &&
              error.errorShowPeriodInDays
            "
            class="text-error"
          >
            {{ error.errorShowPeriodInDays.message }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isSubmit && errorMessageTemplatesArray.length > 0"
      class="text-error"
    >
      <div v-for="(e, i) in errorMessageTemplatesArray" :key="i">
        <div v-if="+e.fieldName.substring(23) === index + 1" class="text-error">
          {{ e.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonMessageTemplate from "components/MessageTemplate/CommonMessageTemplate.vue";
import NumberInput from "components/NumberInput/NumberInput.vue";

export default {
  name: "PushNotificationTemplate",
  components: {NumberInput, CommonMessageTemplate },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    isBroadcast: {
      type: Boolean,
      default: () => false,
    },
    dataId: {
      type: String,
      default: () => "",
    },
    isRemarkShown: {
      type: Boolean,
      default: () => false,
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
    triggerType: {
      type: String,
      default: () => null,
    },
    hasTop40: {
      type: Boolean,
      default: () => false,
    },
    messageTemplate: {
      type: Object,
      default: () => {},
    },
    errorMessageTemplates: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => null,
    },
    errorMessageTemplatesArray: {
      type: Array,
      default: () => [],
    },
    identifier: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    messageTemplatePushNoti: {
      get: function () {
        return this.messageTemplate?.messageTemplatePushNoti;
      },
      set: function (newValue) {
        if (this.messageTemplate) {
          this.messageTemplate.messageTemplatePushNoti = newValue;
        }
      },
    },
    pushNotiTargetUrl: {
      get: function () {
        return this.messageTemplate?.pushNotiTargetUrl;
      },
      set: function (newValue) {
        if (this.messageTemplate) {
          this.messageTemplate.pushNotiTargetUrl = newValue;
        }
      },
    },
    showInInbox: {
      get: function () {
        return this.messageTemplate?.showInInbox;
      },
      set: function (newValue) {
        if (this.messageTemplate) {
          this.messageTemplate.showInInbox = newValue;
        }
      },
    },
    showUntil: {
      get: function () {
        return this.messageTemplate?.showUntil;
      },
      set: function (newValue) {
        if (this.messageTemplate) {
          this.messageTemplate.showUntil = newValue;
        }
      },
    },
    showPeriodInDays: {
      get: function () {
        return this.messageTemplate?.showPeriodInDays;
      },
      set: function (newValue) {
        if (this.messageTemplate) {
          this.messageTemplate.showPeriodInDays = newValue;
        }
      },
    },
    messageTitle: {
      get: function () {
        return this.messageTemplate?.messageTitle;
      },
      set: function (newValue) {
        if (this.messageTemplate) {
          this.messageTemplate.messageTitle = newValue;
        }
      },
    },
    checkMessageTemplatesPushNotiErrorExist() {
      return this.errorMessageTemplatesArray?.find(
        (e) => +e.fieldName.substring(23) === this.index + 1
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.push-notification-message-container {
  border: 2px solid #d2d0d0;
  border-radius: 5px;
}

.text-error {
  color: red;
  font-size: 12px;
}
</style>
